import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { forkJoin, of } from 'rxjs';
import { catchError, map, timeout, switchMap } from 'rxjs/operators';

import { AlertService } from '../../services/alert.service';
import { LoginService } from '../../services/login.service';
import { PersonalService } from '../../services/personal.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';
import { UserService } from '../../services/user.service';

import { environment } from '../../../environments/environment';

@Component({
    selector: 'user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit, OnDestroy {

    legacyHosts: any[];

    legacyAccounts!: any[] | null;

    mykronozAccounts!: any[] | null;

    tooMany!: boolean;

    deleteUserVisible: any = {};

    deleteLegacyAccountVisible: any = {};

    src: any = {};

    dst: any = {};

    dataMigrationSuccess!: boolean;

    constructor(
        private router: Router,
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private userService: UserService,
        private loginService: LoginService,
        private personalService: PersonalService
    ) {
        this.legacyHosts = environment.legacyHosts;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    searchUser(value: string) {

        this.legacyHosts.forEach(legacyHost => this.deleteLegacyAccountVisible[legacyHost.product] = {});
        this.legacyAccounts = null;
        this.mykronozAccounts = null;
        this.tooMany = false;

        value = value.trim();
        if (value.match(/^[^@\s]+@[^@\s]+\.[^@\s\.]+$/) != null) {
            this.searchByEmail(value);
        } else if (value.match(/^[abcdefABCDEF1234567890]{12,}$/) != null) {
            this.searchByAccountId(value.toLowerCase());
        } else {
            this.searchByQuery(value);
        }
    }

    searchByEmail(email: string) {
        this.progressIndicatorService.progress = true;

        let legacyAccounts: any[] = [];

        forkJoin(
            this.legacyHosts.map(legacyHost => {
                return this.userService.searchByEmailOnLegacyServer(legacyHost.product, email)
                    .pipe(
                        timeout(5000),
                        map((data: any) => {
                            return { product: legacyHost.product, data: data };
                        }),
                        catchError((error: any) => {
                            return of({ product: legacyHost.product, data: null, error: error });
                        })
                    )
            })
        ).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.searchByEmail.userService.searchByEmailOnLegacyServer.value', value);
                value.forEach((result: any) => legacyAccounts.push(result));
            },
            error: (error: any) => {
                console.log('UserSearchComponent.searchByEmail.userService.searchByEmailOnLegacyServer.error', error);
            },
            complete: () => {
                console.log('UserSearchComponent.searchByEmail.userService.searchByEmailOnLegacyServer.complete');
                forkJoin([
                    this.userService.searchByEmail(email).pipe(
                        switchMap((switchData: any) => {
                            return this.userService.searchByAccountId(switchData.id).pipe(
                                map((data: any) => {
                                    return {
                                        id: switchData.id,
                                        email: data.account_detail.email,
                                        firstname: data.account_detail.first_name,
                                        lastname: data.account_detail.last_name
                                    };
                                })
                            );
                        }),
                        catchError((error: any) => of({ id: null }))
                    ),
                    this.userService.searchByEmailV2(email).pipe(
                        switchMap((switchData: any) => {
                            return this.loginService.getProfileByAccountIdV2(switchData.accountId).pipe(
                                map((data: any) => {
                                    return {
                                        id: switchData.accountId,
                                        email: switchData.email,
                                        firstname: data.firstname,
                                        lastname: data.lastname
                                    };
                                })
                            );
                        }),
                        catchError((error: any) => of({ id: null }))
                    )
                ]).subscribe({
                    next: ([v1, v2]) => {
                        console.log('UserSearchComponent.searchByEmail.userService.forkJoin.v1', v1);
                        console.log('UserSearchComponent.searchByEmail.userService.forkJoin.v2', v2);
                        this.progressIndicatorService.progress = false;

                        let displayLegacyAccounts: boolean = legacyAccounts
                            .filter(item => item.data == null || item.data.length > 0).length > 0;

                        if (displayLegacyAccounts || (v1.id && v2.id && v1.id != v2.id)) {
                            this.legacyAccounts = legacyAccounts;
                            if (v1.id && v2.id) {
                                if (v1.id != v2.id) {
                                    this.mykronozAccounts = [v1, v2];
                                } else {
                                    this.mykronozAccounts = [v1];
                                }
                            } else if (v1.id) {
                                this.mykronozAccounts = [v1];
                            } else if (v2.id) {
                                this.mykronozAccounts = [v2];
                            } else {
                                this.mykronozAccounts = [];
                            }
                        } else {
                            if (v1.id || v2.id) {
                                this.router.navigate(['/users', v1.id || v2.id]);
                            } else {
                                this.mykronozAccounts = [];
                            }
                        }
                    },
                    error: (error: any) => {
                        console.log('UserSearchComponent.searchByEmail.userService.forkJoin.error', error);
                        this.progressIndicatorService.progress = false;
                    }
                });
            }
        });
    }

    searchByAccountId(accountId: string) {
        this.progressIndicatorService.progress = true;
        this.userService.searchByAccountIdV2(accountId).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.searchByAccountId.userService.searchByAccountIdV2.value', value);
                this.progressIndicatorService.progress = false;
                this.router.navigate(['/users', value.accountId]);
            },
            error: (error: any) => {
                console.log('UserSearchComponent.searchByAccountId.userService.searchByAccountIdV2.error', error);
                this.progressIndicatorService.progress = false;
                if (error.status == 404) {
                    this.progressIndicatorService.progress = true;
                    this.userService.searchByAccountId(accountId).subscribe({
                        next: (value: any) => {
                            console.log('UserSearchComponent.searchByAccountId.userService.searchByAccountId.value', value);
                            this.progressIndicatorService.progress = false;
                            this.router.navigate(['/users', value.id]);
                        },
                        error: (error: any) => {
                            console.log('UserSearchComponent.searchByAccountId.userService.searchByAccountId.error', error);
                            this.progressIndicatorService.progress = false;
                            if (error.status == 404) {
                                this.mykronozAccounts = [];
                            } else {
                                this.alertService.danger('Error');
                            }
                        }
                    });
                } else {
                    this.alertService.danger('Error');
                }
            }
        });
    }

    searchByQuery(query: string) {

        if (query == null || query.trim().length == 0) {
            return;
        }

        this.progressIndicatorService.progress = true;
        this.userService.searchByQueryV2(query).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.searchByQuery.userService.searchByQueryV2.value', value);
                this.progressIndicatorService.progress = false;

                this.mykronozAccounts = value.accounts.map((account: any) => ({
                    id: account.accountId,
                    email: account.email,
                    firstname: account.firstname,
                    lastname: account.lastname,
                    nickname: account.nickname
                }));
            },
            error: (error: any) => {
                console.log('UserSearchComponent.searchByQuery.userService.searchByQueryV2.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');

                this.mykronozAccounts = null;
                this.tooMany = error.status == 409;
            }
        });
    }

    displayDeleteUser(accountId: string) {
        this.deleteUserVisible[accountId] = true;
        setTimeout(() => this.deleteUserVisible[accountId] = false, 3000);
    }

    deleteUser(accountId: string) {
        this.progressIndicatorService.progress = true;
        this.userService.deleteAccountV2(accountId).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.deleteUser.userService.deleteAccountV2.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');

                if (this.mykronozAccounts) {
                    this.mykronozAccounts = this.mykronozAccounts.filter(item => item.id != accountId);
                }
            },
            error: (error: any) => {
                console.log('UserSearchComponent.deleteUser.userService.deleteAccountV2.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    displayDeleteLegacyAccount(product: string, email: string) {
        this.deleteLegacyAccountVisible[product][email] = true;
        setTimeout(() => this.deleteLegacyAccountVisible[product][email] = false, 3000);
    }

    deleteLegacyAccount(product: string, email: string) {
        this.progressIndicatorService.progress = true;
        this.userService.deleteByEmailOnLegacyServer(product, email).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.deleteLegacyAccount.userService.deleteByEmailOnLegacyServer.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');

                if (this.legacyAccounts) {
                    let item = this.legacyAccounts.find(legacyAccount => legacyAccount.product == product);
                    if (item && item.data) {
                        item.data = item.data.filter((value: any) => value != email);
                    }
                }
            },
            error: (error: any) => {
                console.log('UserSearchComponent.deleteLegacyAccount.userService.deleteByEmailOnLegacyServer.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    reviewDataMigration(src: string, dst: string) {

        this.src = {};
        this.dst = {};
        this.dataMigrationSuccess = false;

        let match = null;
        src = src.trim();
        dst = dst.trim();
        if (src.startsWith('#')) {
            src = src.substring(1);
        }
        if (dst.startsWith('#')) {
            dst = dst.substring(1);
        }

        let block: boolean = false;
        if ((match = src.match(/^[abcdefABCDEF1234567890]{12,}$/)) == null) {
            this.alertService.danger(`Invalid Account ID: ${src}`);
            block = true;
        }
        if ((match = dst.match(/^[abcdefABCDEF1234567890]{12,}$/)) == null) {
            this.alertService.danger(`Invalid Account ID: ${dst}`);
            block = true;
        }
        if (block) {
            return;
        }

        this.progressIndicatorService.progress = true;
        this.userService.searchByAccountId(src).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.reviewDataMigration.userService.searchByAccountId.value', value);
                this.src.account = value;
                this.userService.searchByAccountId(dst).subscribe({
                    next: (value: any) => {
                        console.log('UserSearchComponent.reviewDataMigration.userService.searchByAccountId.value', value);
                        this.dst.account = value;
                        this.personalService.getFullPersonalAvatarByAccountId(src).subscribe({
                            next: (value: any) => {
                                console.log('UserSearchComponent.reviewDataMigration.personalService.getFullPersonalAvatarByAccountId.value', value);
                                this.src.personal = value;
                                this.personalService.getFullPersonalAvatarByAccountId(dst).subscribe({
                                    next: (value: any) => {
                                        console.log('UserSearchComponent.reviewDataMigration.personalService.getFullPersonalAvatarByAccountId.value', value);
                                        this.dst.personal = value;
                                        this.progressIndicatorService.progress = false;
                                    },
                                    error: (error: any) => {
                                        console.log('UserSearchComponent.reviewDataMigration.personalService.getFullPersonalAvatarByAccountId.error', error);
                                        this.progressIndicatorService.progress = false;
                                    }
                                });
                            },
                            error: (error: any) => {
                                console.log('UserSearchComponent.reviewDataMigration.personalService.getFullPersonalAvatarByAccountId.error', error);
                                this.progressIndicatorService.progress = false;
                            }
                        });
                    },
                    error: (error: any) => {
                        console.log('UserSearchComponent.reviewDataMigration.userService.searchByAccountId.error', error);
                        this.progressIndicatorService.progress = false;
                        this.alertService.danger('Error');
                        this.dst.error = true;
                    }
                });
            },
            error: (error: any) => {
                console.log('UserSearchComponent.reviewDataMigration.userService.searchByAccountId.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.src.error = true;
            }
        });
    }

    queueDataMigration(src: string, dst: string) {
        this.progressIndicatorService.progress = true;
        this.userService.getMigrationCode(dst).subscribe({
            next: (value: any) => {
                console.log('UserSearchComponent.queueDataMigration.userService.getMigrationCode.value', value);
                let code: string = value.code;
                this.userService.queueDataMigration(src, code).subscribe({
                    next: (value: any) => {
                        console.log('UserSearchComponent.queueDataMigration.userService.queueDataMigration.value', value);
                        this.progressIndicatorService.progress = false;
                        this.dataMigrationSuccess = true;
                    },
                    error: (error: any) => {
                        console.log('UserSearchComponent.queueDataMigration.userService.queueDataMigration.error', error);
                        this.progressIndicatorService.progress = false;
                        this.alertService.danger('Error');
                    }
                });
            },
            error: (error: any) => {
                console.log('UserSearchComponent.queueDataMigration.userService.getMigrationCode.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
